import {
    useLocalStorage,
    LocalStorageKeys,
} from '../useLocalStorage/useLocalStorage'
import {
    useSessionStorage,
    SessionStorageKeys,
} from '../useSessionStorage/useSessionStorage'

export const useLogout = () => {
    const { removeItem } = useLocalStorage()
    const { removeItem: removeSessionData } = useSessionStorage()

    const logout = () => {
        removeItem(LocalStorageKeys.ACCESS_TOKEN)
        removeItem(LocalStorageKeys.REFRESH_TOKEN)
        removeItem(LocalStorageKeys.USER)
        removeSessionData(SessionStorageKeys.ACCESS_TOKEN)
        removeSessionData(SessionStorageKeys.REFRESH_TOKEN)
        removeSessionData(SessionStorageKeys.USER)
        window.location.href = '/login'
    }

    return [logout]
}
